/**
 * Hero background video loader.
 *
 * The hero section renders both desktop and mobile media and hides one with
 * CSS. A <video> carrying a real `src` is downloaded by the browser even when
 * its wrapper is `display: none`, and `preload="none"` does not stop it because
 * `autoplay` overrides preload. snippets/hero-video.liquid therefore emits the
 * URL as `data-src`; this module promotes it to `src` and calls load() only for
 * videos whose `data-hero-scope` matches the current viewport.
 *
 * The breakpoint below is the same one sections/hero.liquid uses in its own
 * stylesheet to swap .hero__media-wrapper--desktop / --mobile. Keep them in sync.
 */

const DESKTOP_QUERY = '(min-width: 750px)';

function scopeMatches(scope, isDesktop) {
  if (scope === 'desktop') return isDesktop;
  if (scope === 'mobile') return !isDesktop;
  return true; // 'always' — the element is displayed at every viewport
}

function activate(video) {
  if (video.dataset.heroVideoLoaded === 'true') return;

  const sources = video.querySelectorAll('source[data-src]');
  if (!sources.length) return;

  sources.forEach((source) => {
    source.setAttribute('src', source.dataset.src);
    source.removeAttribute('data-src');
  });

  video.dataset.heroVideoLoaded = 'true';
  video.load();

  // autoplay+muted normally starts on its own, but load() resets the element,
  // so nudge it and swallow the rejection if the browser declines.
  const played = video.play();
  if (played && typeof played.catch === 'function') played.catch(() => {});
}

function sync() {
  const isDesktop = window.matchMedia(DESKTOP_QUERY).matches;
  document.querySelectorAll('video[data-hero-video]').forEach((video) => {
    if (scopeMatches(video.dataset.heroScope || 'always', isDesktop)) activate(video);
  });
}

sync();

const mql = window.matchMedia(DESKTOP_QUERY);
if (typeof mql.addEventListener === 'function') {
  mql.addEventListener('change', sync);
} else if (typeof mql.addListener === 'function') {
  mql.addListener(sync); // Safari < 14
}

// Theme editor re-renders the section without a full page load.
document.addEventListener('shopify:section:load', sync);
